// extracted by mini-css-extract-plugin
export default {"storeModal":"store-modal_storeModal__nZX39","closeBtn":"store-modal_closeBtn__l1qPw"};